import React from 'react';

const ApplePass: React.FC = () => null;

export default ApplePass;
